import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_btb379emrh: FaireBrandEntity = {
  token: "b_btb379emrh",
  type: "brand",
  name: "Mel Andrel",
  avatarUrl:
    "https://cdn.faire.com/fastly/5e7515f658089612334ab4bcac42fa42439b22f76a124600bc6a05a4ac1f6d7f.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/0409eb63b07dd4d0bf4399ef647c84aa374a0f7a06f0a28cba92645acd28d2e9.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/5e7515f658089612334ab4bcac42fa42439b22f76a124600bc6a05a4ac1f6d7f.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/0409eb63b07dd4d0bf4399ef647c84aa374a0f7a06f0a28cba92645acd28d2e9.jpeg",
  location: "Kingston, NY, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 33,
  isTopShop: true,
  isInsider: true,
  description:
    "Mel Andrel is a design-forward stationery and lifestyle brand inspired by food, community, and a touch of play. Founded by designer Mel Andrel after leaving the traditional 9–5, the brand was built around a more creative, flexible way of working — and a belief that everyday objects can be functional, attractive and inspiring. \n\nWhat began as a small collection of illustrated paper goods has grown into a distinct stationery brand now carried in 600+ retailers worldwide and featured in publications like Real Simple, Better Homes & Gardens, The Strategist, and Wirecutter.\n\nToday, Mel Andrel continues to bring a fresh perspective to the stationery aisle with colorful, food-themed designs that turn everyday desk essentials into conversation pieces.\nEvery product begins as an original illustration or design created by hand. From design to sourcing trusted manufacturing partners, we oversee every step of the process and hand-assemble and pack each order with care in our studio.\n\nPS. If ordering for the first time, please use our Faire Direct link faire.com/direct/melandrel or contact us at wholesale.melandrel.com for more info.\nAll designs © Mel Andrel 2023–Present. ",
  meta: {
    source: "api",
    importedAt: "2026-05-06T02:36:57.835Z",
    importedBy: "entity-db-cli",
  },
};
